import { render } from "./youtube.svg?vue&type=template&id=1302bd66"
const script = {}
script.render = render

export default script